import React, { useEffect, useRef } from 'react'
import Tooltip from '@mui/material/Tooltip'
import { AutocompleteFetch } from '@/javascript/presentation/components/inputs'

type viewOption = { label: string; value: string }

type Props = {
  workFinishOptions: viewOption[]
  setWorkFinishOptions: (options: viewOption[]) => void
  fetchWorkFinishOptions: (searchText?: string) => Promise<viewOption[]>
  workStatus: string
}

const WorkFinishOptionsInput: React.FC<Props> = ({
  workFinishOptions, setWorkFinishOptions, fetchWorkFinishOptions, workStatus
}) => {
  const isMounted = useRef(false)

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }
    if (workStatus !== 'finished') setWorkFinishOptions([])
  }, [workStatus])

  return (
    <Tooltip
      title={'Esse filtro só pode ser aplicado em atividades com status "Finalizado"'} placement="right" arrow
      disableHoverListener={workStatus === 'finished'}
      disableFocusListener={workStatus === 'finished'}
      disableTouchListener={workStatus === 'finished'}
    >
      <span>
        <AutocompleteFetch
          label="Tipo de finalização" value={workFinishOptions} setValue={setWorkFinishOptions}
          fetchOptions={fetchWorkFinishOptions}
          disabled={workStatus !== 'finished'}
        />
      </span>
    </Tooltip>
  )
}

export default WorkFinishOptionsInput
